<template>
    <tooltip
        v-if="
            $page.props.auth.user.group_admin_permission_level === 'read-only'
        "
        width-px="300"
    >
        <template #trigger>
            <div class="btn btn-primary opacity-25">
                <div class="flex items-center gap-2">
                    <svg
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.5 1.04167V10.9583"
                            stroke="white"
                            stroke-width="1.41667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M1.54175 6H11.4584"
                            stroke="white"
                            stroke-width="1.41667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <span>Invite an Admin</span>
                </div>
            </div>
        </template>
        <template #content>
            Only group owners and full admins are able to invite new admins
        </template>
    </tooltip>

    <new-modal v-else title="Invite an Admin" size="xl" ref="inviteAdminModal">
        <template #trigger>
            <div class="btn btn-primary">+ Invite an Admin</div>
        </template>
        <template #content>
            <div class="flex flex-col gap-4">
                <div class="flex flex-row gap-2">
                    <div class="">
                        <form-input
                            v-model="form.firstName"
                            label="First Name"
                            name="first_name"
                        />
                    </div>
                    <div class="">
                        <form-input
                            v-model="form.lastName"
                            label="Last Name"
                            name="last_name"
                        />
                    </div>
                </div>
                <div class="flex gap-2">
                    <div class="">
                        <form-input
                            v-model="form.email"
                            label="Email"
                            name="email"
                            hint="A temporary password will be included in the welcome email sent to this user."
                        />
                    </div>
                </div>
                <hr />
                <div class="">
                    <form-radio
                        :options="permissionOptions"
                        name="permission_level_id"
                        label="Role"
                        id="permission_level_id"
                        v-model="form.permissionLevelId"
                    ></form-radio>
                </div>
            </div>
            <div class="mt-12 flex justify-end gap-4">
                <span class="btn btn-transparent" @click="cancel">Cancel</span>
                <span
                    :class="
                        'btn btn-primary' +
                        ' ' +
                        (form.isDirty
                            ? 'opacity-100'
                            : 'opacity-50 hover:cursor-not-allowed')
                    "
                    @click="submit"
                    >Invite Admin</span
                >
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";
import FormInput from "@/Components/FormInput";
import FormRadio from "@/Components/FormRadio";
import Tooltip from "@/Components/Tooltip";

export default {
    name: "GroupInviteAnAdminModal",
    components: { FormRadio, FormInput, NewModal, Tooltip },
    data() {
        return {
            form: this.$inertia.form({
                firstName: "",
                lastName: "",
                email: "",
                permissionLevelId: "3",
            }),
            permissionOptions: [
                {
                    value: 2,
                    label: '<span class="font-semibold">Full Access:</span><span class="text-gray-750"> Can invite and manage new admins & students</span>',
                },
                {
                    value: 3,
                    label: '<span class="font-semibold">Read-only:</span><span class="text-gray-750"> Can see everything but can’t take any actions.</span>',
                },
            ],
        };
    },
    methods: {
        submit() {
            let vm = this;

            vm.$inertia.post(route("group.admins.create-invite"), vm.form, {
                onSuccess: function () {
                    vm.cancel();
                },
            });
        },
        cancel() {
            this.form.reset();
            this.$refs.inviteAdminModal.closeModal();
        },
    },
};
</script>
